<script setup lang="ts">
import {useDialogPluginComponent} from 'quasar'
import {storeToRefs} from "pinia";
import {useNamaFlagsStore} from "@/stores/nama-flags-store.ts";
import DialogCloseIcon from "@/assets/editViewIcons/DialogCloseIcon.vue";
import {PropType, ref} from "vue";
import {CommonDialogAction} from "@/utils/forms/DialogHandler.ts";
import WidgetContainer from "@/components/EditView/widgets/WidgetContainer.vue";
import EditScreenField = namaTypes.EditScreenField;

const props = defineProps({
  textToCopy: {type: String, required: true},
  title: {type: String},
  button: {type: Object as PropType<CommonDialogAction>, required: true}
})

let text = ref(props.textToCopy);
const field: EditScreenField = {id: "Text"}

defineEmits([
  // REQUIRED; need to specify some events that your
  // component will emit through useDialogPluginComponent()
  ...useDialogPluginComponent.emits
])

const {compactMode} = storeToRefs(useNamaFlagsStore());

const {dialogRef, onDialogHide, onDialogOK, onDialogCancel} = useDialogPluginComponent()

function onClick() {
  if (props.button?.action)
    props.button.action()
  onDialogOK();
}
</script>

<template>

  <q-dialog ref="dialogRef" @hide="onDialogHide" persistent>
    <q-card class="tw-shadow-none dark:tw-bg-namaBackground-deep-dark tw-bg-namaBackground-deep-light !tw-rounded-none tw-min-w-[320px]">
      <q-bar v-if="title" class="tw-text-xs tw-text-namaFontColor-light tw-bg-[#CED4DA] dark:tw-bg-[#212529] dark:tw-text-white tw-h-10">
        <div>{{ title }}</div>
        <q-space/>
        <q-btn dense flat @click="onDialogCancel" title="Close" class="nama-btn-hover nama-custom-btn focus:tw-bg-transparent">
          <q-avatar square class="tw-w-5">
            <DialogCloseIcon/>
          </q-avatar>
        </q-btn>
      </q-bar>
      <q-card-section class="tw-text-primary-light dark:tw-text-primary-dark tw-text-base tw-font-normal">
        <WidgetContainer :field="field" :doNotApplyThemeLayouts="true" :isInsideComposite="false">
          <template v-slot:widget>
            <q-input outlined dense hide-bottom-space
                     type="textarea"
                     :id="textToCopy"
                     autocomplete="off"
                     class="nama-field-input nama-customize-dense-input nama-focused-input"
                     input-class="nama-input-class"
                     v-model="text">
            </q-input>
          </template>
        </WidgetContainer>
      </q-card-section>
      <q-card-section class="tw-flex tw-flex-row tw-gap-4 tw-justify-center">
        <q-btn
          v-if="button"
          :label="button.id"
          @click="onClick"
          :dense="compactMode"
          class="tw-bg-primary-light dark:tw-text-primary-dark tw-text-base tw-font-normal tw-rounded-md tw-px-6"/>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<style scoped>

</style>
